<template>
  <div id="my-info">
    <the-top-bar showUser />
    <div class="row no-bottom-margins">
      <div class="site-constrains">
        <div class="home-profile-header indigo accent-3 z-depth-1">
          <div class="title-image">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="188.662"
              height="140.701" viewBox="0 0 188.662 140.701">
              <defs>
                <linearGradient id="a" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#c43f21"></stop>
                  <stop offset="1" stop-color="#b56855"></stop>
                </linearGradient>
                <linearGradient id="b" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                  <stop offset="0"></stop>
                  <stop offset="1" stop-opacity="0.239"></stop>
                </linearGradient>
                <linearGradient id="c" x1="0.5" y1="-0.164" x2="0.5" y2="1.182" gradientUnits="objectBoundingBox">
                  <stop offset="0.01" stop-color="#53a3a3"></stop>
                  <stop offset="0.99" stop-color="gray"></stop>
                </linearGradient>
                <linearGradient id="d" x1="0.436" y1="2.467" x2="0.504" y2="0.143" gradientUnits="objectBoundingBox">
                  <stop offset="0.01" stop-color="#ccf3ff"></stop>
                  <stop offset="0.99" stop-color="gray"></stop>
                </linearGradient>
                <linearGradient id="e" x1="0.456" y1="2.475" x2="0.508" y2="0.142" xlink:href="#d"></linearGradient>
                <linearGradient id="f" x1="0.474" y1="-0.128" x2="0.54" y2="1.188" xlink:href="#c"></linearGradient>
                <linearGradient id="g" x1="0.065" y1="2.171" x2="0.559" y2="0.239" xlink:href="#d"></linearGradient>
                <linearGradient id="h" x1="0.07" y1="2.112" x2="0.564" y2="0.244" xlink:href="#d"></linearGradient>
                <linearGradient id="i" x1="0.5" x2="0.5" y2="0.5" gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#ed9962"></stop>
                  <stop offset="1" stop-color="#f7d69c"></stop>
                </linearGradient>
                <linearGradient id="j" x1="0.5" y1="0.915" x2="0.5" y2="0.018" gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#b56855"></stop>
                  <stop offset="1" stop-color="#e2a67c"></stop>
                </linearGradient>
                <linearGradient id="k" x1="0.463" y1="1.507" x2="0.525" y2="-0.031" xlink:href="#c"></linearGradient>
                <linearGradient id="l" x1="0.356" y1="1.05" x2="0.537" y2="0.356" xlink:href="#c"></linearGradient>
                <linearGradient id="m" x1="-0.553" y1="3.561" x2="0.784" y2="-0.329" xlink:href="#d"></linearGradient>
                <linearGradient id="n" x1="-0.108" y1="3.781" x2="0.667" y2="-0.399" xlink:href="#d"></linearGradient>
                <linearGradient id="o" x1="-0.942" y1="3.559" x2="0.884" y2="-0.335" xlink:href="#d"></linearGradient>
                <linearGradient id="p" x1="0.144" y1="1.398" x2="0.809" y2="-0.41" xlink:href="#c"></linearGradient>
                <linearGradient id="q" x1="-1.896" y1="2.09" x2="0.937" y2="0.208" xlink:href="#d"></linearGradient>
                <linearGradient id="r" x1="-1.123" y1="2.36" x2="0.807" y2="0.144" xlink:href="#d"></linearGradient>
                <linearGradient id="s" x1="-2.488" y1="2.037" x2="1.015" y2="0.196" xlink:href="#d"></linearGradient>
              </defs>
              <g transform="translate(-34.222 -448.214)">
                <g transform="translate(-214 221)">
                  <g transform="translate(293.399 219.917)">
                    <g transform="translate(2.25 11)">
                      <path d="M135.752,198.81l.45,28.028-13.193.061-.668-28.089Z" transform="translate(-83.882 -112.014)"
                        fill="#edc094"></path>
                      <path
                        d="M136.2,208.353q-.087-3.379-.2-6.758c-3.554,0-7.107-.044-10.648,0,.022,2.222.074,4.44.114,6.658Q130.84,208.443,136.2,208.353Z"
                        transform="translate(-85.578 -113.572)" fill="#e4aa79"></path>
                      <path
                        d="M126.2,244.442q.079,3.466.153,6.928,5.169.044,10.3.1c.026-1.445.052-2.89.1-4.34.026-.96.022-1.921.035-2.877H136.6C133.159,244.236,129.645,244.577,126.2,244.442Z"
                        transform="translate(-86.057 -137.615)" fill="#e4aa79"></path>
                      <path
                        d="M136.554,229.685q0-3.2-.07-6.387c-3.58.052-7.164.026-10.744-.118q.065,3.346.148,6.684C129.407,230.039,133.013,229.729,136.554,229.685Z"
                        transform="translate(-85.797 -125.745)" fill="#e4aa79"></path>
                      <path
                        d="M134.86,193.623V223.9h-1.921l-.437-28.028h-13.42l.668,28.089h-1.89c-.092-2.24-1.31-30.355-1.31-30.355Z"
                        transform="translate(-80.62 -109.084)" fill="#d4a674"></path>
                      <path
                        d="M126.174,171.4l-.987,11.967L123,209.5l-.144,1.746-29.12.122V181.109H75.4s1.236,28.12,1.31,30.355l-30.888.135L43.6,171.4Z"
                        transform="translate(-39.518 -96.571)" fill="url(#a)"></path>
                      <path
                        d="M126.174,171.4l-.987,11.967L123,209.5l-.144,1.746-29.12.122V181.109H75.4s1.236,28.12,1.31,30.355l-30.888.135L43.6,171.4Z"
                        transform="translate(-39.518 -96.571)" opacity="0.13" fill="url(#b)"></path>
                      <path d="M43.6,171.4l.672,11.949c25.832-3.872,54.092-5.676,80.937-.244l.965-11.7Z"
                        transform="translate(-39.518 -96.571)" opacity="0.23"></path>
                      <path d="M75.89,193.64l.664,17.777H91.677l-.489-17.777Z" transform="translate(-57.711 -109.101)"
                        fill="#4d2e18"></path>
                      <path d="M75.89,193.64l.664,17.777H91.677l-.489-17.777Z" transform="translate(-57.711 -109.101)"
                        fill="url(#c)"></path>
                      <path
                        d="M86.461,193.64H81.1q0,4.4.135,8.793c1.746-.079,3.528-.188,5.278-.345a48.383,48.383,0,0,0-.052-8.448Z"
                        transform="translate(-60.646 -109.101)" fill="url(#d)"></path>
                      <path d="M102.163,193.64H95.37V202c2.344-.218,4.676-.489,6.985-.79Z"
                        transform="translate(-68.686 -109.101)" fill="url(#e)"></path>
                      <path d="M91.21,193.64H75.93l.664,17.773H91.717ZM78.078,209.854l-.55-14.652H89.691l.406,14.652Z"
                        transform="translate(-57.733 -109.101)" fill="#d4a674"></path>
                      <path d="M77.95,210.338l13.97-.358v1.266l-13.543.847Z" transform="translate(-58.872 -118.307)"
                        fill="#d4a674"></path>
                      <path d="M91.94,195.32l.293,7.6.878-.14v-7.46Z" transform="translate(-66.754 -110.048)"
                        fill="#d4a674"></path>
                      <path d="M165.02,193.64l.664,17.777h15.127l-.493-17.777Z" transform="translate(-107.929 -109.101)"
                        fill="#4d2e18"></path>
                      <path d="M165.02,193.64l.664,17.777h15.127l-.493-17.777Z" transform="translate(-107.929 -109.101)"
                        fill="url(#f)"></path>
                      <path d="M192.054,193.64h-6.2v7.8q3.191-.2,6.4-.489Z" transform="translate(-119.665 -109.101)"
                        fill="url(#g)"></path>
                      <path
                        d="M169.42,193.629c.21,2.777.677,5.4.79,8.059,1.855-.022,3.724-.1,5.6-.21a37.867,37.867,0,0,0-.629-7.858Z"
                        transform="translate(-110.408 -109.09)" fill="url(#h)"></path>
                      <path d="M180.306,193.64H165l.664,17.773h15.123Zm-13.124,16.214-.55-14.652H178.8l.406,14.652Z"
                        transform="translate(-107.917 -109.101)" fill="#d4a674"></path>
                      <path d="M167.55,209.16h13.709v1.1l-13.709.45Z" transform="translate(-109.354 -117.845)"
                        fill="#d4a674"></path>
                      <path d="M181.09,195.32l.389,7.016,1.17-.2V195.32Z" transform="translate(-116.983 -110.048)"
                        fill="#d4a674"></path>
                      <path
                        d="M68.91,171.4H60.79c.847,13.451,1.371,26.876,2.358,40.165l9.085-.039a60.987,60.987,0,0,0,.755-9.024h-5.4C67.622,192.137,68.207,181.769,68.91,171.4Z"
                        transform="translate(-49.203 -96.571)" opacity="0.3"></path>
                      <path d="M97.594,12.86l31.56,38.332-.664,32.765H67.562l-1.6-32.682Z"
                        transform="translate(-52.116 -7.246)" fill="#f7da9f"></path>
                      <path d="M97.594,12.86l31.56,38.332-.664,32.765H67.562l-1.6-32.682Z"
                        transform="translate(-52.116 -7.246)" fill="url(#i)"></path>
                      <path d="M66,95.019,67.6,127.7h2.567c-.437-12.438-.223-24.885-.437-37.2Z"
                        transform="translate(-52.139 -50.99)" opacity="0.13"></path>
                      <path d="M205.932,94.862l-3.7-4.492c.7,12.521.113,24.85.231,37.258h2.8Z"
                        transform="translate(-128.894 -50.916)" opacity="0.11"></path>
                      <path d="M135.231,12.86l-2.471,3q2.275-.244,4.575-.437Z" transform="translate(-89.753 -7.246)"
                        fill="#eea96e"></path>
                      <path
                        d="M135.559,30.4,134.3,28.87l-6.924.581a49.932,49.932,0,0,0-5.876.982l-.611.742.873-.1a137.391,137.391,0,0,1,13.8-.672Z"
                        transform="translate(-83.065 -16.266)" fill="#eea96e"></path>
                      <path
                        d="M133.808,43.21l-3.261.026a174.1,174.1,0,0,0-17.52,1.026l-2.082.214-.074.092c7.679-.336,15.411-1.179,23.056-1.214Z"
                        transform="translate(-77.419 -24.345)" fill="#eea96e"></path>
                      <path
                        d="M132.715,55.759l-.9-1.091c-1.183-.022-2.366-.052-3.554-.061-9.129-.07-18.428,1.17-27.614,1.332l-.7.847c4.292-.236,8.583-.93,12.923-1.017C119.487,55.65,126.084,55.514,132.715,55.759Z"
                        transform="translate(-71.267 -30.765)" fill="#e8ab67" opacity="0.63"></path>
                      <path
                        d="M97.784,71.161c7.627-.934,15.28-.825,22.938-.873l9.426-.074-.773-.934c-1.541-.079-3.078-.153-4.623-.21a185.359,185.359,0,0,0-23.257.266,101.961,101.961,0,0,1-13.757.777l-1.7,2.065C90.017,72.4,94.357,71.584,97.784,71.161Z"
                        transform="translate(-63.43 -38.784)" fill="#e8ab67" opacity="0.63"></path>
                      <path
                        d="M100.374,94.321c-2.082.157-4.174.437-6.274.751,12.412-.921,24.789-1.441,37.332-1.161,4.034.092,8.046.437,12.041.873v-.022q-7.636-.95-15.376-1.139a271.533,271.533,0,0,0-27.723.7Z"
                        transform="translate(-67.971 -52.698)" fill="#e8ab67" opacity="0.63"></path>
                      <path
                        d="M113.841,106.837A470.18,470.18,0,0,0,66.45,109.02l.026.5c14.721-2.253,29.613-1.991,44.483-1.336,6.112.271,12.255.633,18.336,1.366l.039-1.943C124.218,107.152,119.079,106.9,113.841,106.837Z"
                        transform="translate(-52.392 -60.184)" fill="#e8ab67" opacity="0.63"></path>
                      <path
                        d="M67,120.588l.022.485c6.815.738,13.682-.834,20.519-.952,8.579-.153,17.179.079,25.758.336q8.107.242,16.215.616v-.437c-5.4-.672-10.849-1.061-16.289-1.31C97.818,118.663,82.306,118.165,67,120.588Z"
                        transform="translate(-52.702 -66.924)" fill="#e8ab67" opacity="0.63"></path>
                      <path
                        d="M84.762,133.342c-5.676.472-11.417,1.249-17.092.781l.022.467c6.265,1.384,12.879.5,19.244.188,8.443-.415,17.027-.585,25.457-.183a128.926,128.926,0,0,1,17.376,1.834l.048-2.34c-6.042-.266-12.084-.5-18.127-.655C102.771,133.211,93.651,132.6,84.762,133.342Z"
                        transform="translate(-53.08 -74.928)" fill="#e8ab67" opacity="0.63"></path>
                      <path
                        d="M116.741,150.423l5.588.1c-3.148-.4-6.322-.677-9.535-.79-8.963-.319-18.026-.284-26.981.271-5.75.358-11.713.873-17.424-.1l.1,2.065c6.584-1.183,13.591-1.236,20.083-1.454C97.951,150.2,107.346,150.257,116.741,150.423Z"
                        transform="translate(-53.485 -84.247)" fill="#e8ab67" opacity="0.63"></path>
                      <path
                        d="M89.011,163.07c-6.426.262-13.355.253-19.821,1.5l.192,3.877h60.929l.1-5.265c-4.409-.057-8.819-.135-13.224-.21C107.8,162.821,98.4,162.69,89.011,163.07Z"
                        transform="translate(-53.936 -91.738)" fill="#eea96e"></path>
                      <path
                        d="M175.619,82.136q3.431.188,6.841.485l-.62-.751q-5.2.039-10.391.092Q173.532,82.027,175.619,82.136Z"
                        transform="translate(-111.552 -46.127)" fill="#e8ab67" opacity="0.63"></path>
                      <path d="M77.533,85.43l-.873,1.061a69.793,69.793,0,0,0,8.382-.873,31.822,31.822,0,0,1-7.509-.188Z"
                        transform="translate(-58.145 -48.133)" fill="#e8ab67" opacity="0.63"></path>
                      <path d="M53.362,44.029,49.2,49.067H43.6L85,0l42.466,49.067h-6.684l-4.222-5.121L85,5.614Z"
                        transform="translate(-39.518)" fill="#b36453"></path>
                      <path d="M53.362,44.029,49.2,49.067H43.6L85,0l42.466,49.067h-6.684l-4.222-5.121L85,5.614Z"
                        transform="translate(-39.518)" fill="url(#j)"></path>
                      <path d="M60.591,100.85l1.6,32.682H57.836L56.43,105.888Z" transform="translate(-46.747 -56.821)"
                        fill="#d4a674"></path>
                      <path d="M56.43,108.384l1.406,27.644h2.336L58.993,105.28Z" transform="translate(-46.747 -59.317)"
                        fill="#f0cd97"></path>
                      <path d="M56.43,105.888l.244,4.8q2.1-2.227,4.178-4.466l-.244-5.374Z"
                        transform="translate(-46.747 -56.821)" opacity="0.13"></path>
                      <path d="M209.854,100.66l4.222,5.121-.563,27.644H209.19Z" transform="translate(-132.815 -56.714)"
                        fill="#f0cd97"></path>
                      <path d="M212.207,103.515l-2.353-2.855-.664,32.765h2.484Z" transform="translate(-132.815 -56.714)"
                        fill="#d4a674" opacity="0.78"></path>
                      <path d="M210.569,100.66,210.46,106c1.406,1.8,2.8,3.584,4.217,5.348l.113-5.558Z"
                        transform="translate(-133.531 -56.714)" opacity="0.13"></path>
                      <path
                        d="M97.617,12.86,66,51.274l.231,4.706C76.976,44.067,87.392,31.917,98.01,20.247c10.718,11.377,20.86,23.339,31.084,35.219l.087-4.274Z"
                        transform="translate(-52.139 -7.682)" opacity="0.17"></path>
                      <path d="M68.5,152.78l.489,10.015h60.933l.183-8.98C110.857,158.08,88.622,157.412,68.5,152.78Z"
                        transform="translate(-53.547 -86.08)" fill="#e6ad65" opacity="0.68"></path>
                      <path d="M35.966,173.176,34.25,164.92l89.787,1.6-1.847,6.653Z" transform="translate(-34.25 -92.92)"
                        fill="#b36453"></path>
                      <path d="M123.327,171.181l.86-2.51L37.02,167.54l.646,2.532Z" transform="translate(-35.811 -94.396)"
                        fill="#fff" opacity="0.15"></path>
                      <path d="M53.03,183.83l1.406,30.6h5.837v-30.6Z" transform="translate(-44.831 -103.574)"
                        fill="#d4a674"></path>
                      <path d="M56.758,183.83H53.03l1.406,30.6h3.37Z" transform="translate(-44.831 -103.574)"
                        fill="#eeca94"></path>
                      <path d="M53,183.83l.122,2.65a12.9,12.9,0,0,1,7.121.55v-3.2Z"
                        transform="translate(-44.814 -103.574)" opacity="0.29"></path>
                      <path d="M205.95,183.83v30.6h5.322l2.109-30.6Z" transform="translate(-130.99 -103.574)"
                        fill="#d4a674"></path>
                      <path d="M209.133,183.83H205.95v30.6h1.925Z" transform="translate(-130.99 -103.574)" opacity="0.1">
                      </path>
                      <path d="M206,183.819v2.694a19.275,19.275,0,0,1,7.26-.271l.166-2.432Z"
                        transform="translate(-131.018 -103.563)" opacity="0.23"></path>
                      <path d="M43.6,251.37H59.024l-.886,7.968H46.019Z" transform="translate(-39.518 -141.627)"
                        fill="#66baa6"></path>
                      <path d="M209.739,251.37H194.31l.886,7.968h12.119Z" transform="translate(-124.431 -141.627)"
                        fill="#66baa6"></path>
                      <path
                        d="M130.263,51.172l6.466-.5s1.991-9.055-3.235-9.055C127.9,41.62,130.263,50.675,130.263,51.172Z"
                        transform="translate(-88.068 -23.45)" fill="#75381e"></path>
                      <path
                        d="M130.263,51.172l6.466-.5s1.991-9.055-3.235-9.055C127.9,41.62,130.263,50.675,130.263,51.172Z"
                        transform="translate(-88.068 -23.45)" fill="#b36453"></path>
                      <path
                        d="M133.587,51.5c-.541-3.6-.048-5.125.489-5.767a1.681,1.681,0,0,1,1.441-.559,1.462,1.462,0,0,1,1.279.537c.873,1.091.873,3.606.624,5.492Z"
                        transform="translate(-90.086 -25.448)" fill="#75381e"></path>
                      <path
                        d="M133.587,51.5c-.541-3.6-.048-5.125.489-5.767a1.681,1.681,0,0,1,1.441-.559,1.462,1.462,0,0,1,1.279.537c.873,1.091.873,3.606.624,5.492Z"
                        transform="translate(-90.086 -25.448)" fill="url(#k)"></path>
                      <path d="M81.487,129.267l-.777-22.6H96.785v22.6Z" transform="translate(-60.427 -60.1)"
                        fill="#75381e"></path>
                      <path d="M81.487,129.267l-.777-22.6H96.785v22.6Z" transform="translate(-60.427 -60.1)"
                        fill="#b36453"></path>
                      <path d="M85.078,129.72l-.668-19.48h12.9v19.48Z" transform="translate(-62.511 -62.112)"
                        fill="#75381e"></path>
                      <path d="M85.078,129.72l-.668-19.48h12.9v19.48Z" transform="translate(-62.511 -62.112)"
                        fill="url(#l)"></path>
                      <path d="M85.74,111.65l.227,6.431h2.75c-.223-2.117-.48-4.244-.62-6.431Z"
                        transform="translate(-63.261 -62.906)" fill="url(#m)"></path>
                      <path d="M94.884,118.076h5.27V111.65H94.64Z" transform="translate(-68.275 -62.906)" fill="url(#n)">
                      </path>
                      <path d="M109,111.65v6.431h2.183V111.65Z" transform="translate(-76.366 -62.906)" fill="url(#o)">
                      </path>
                      <path d="M175.838,129.267l.773-22.6H160.54v22.6Z" transform="translate(-105.405 -60.1)"
                        fill="#75381e"></path>
                      <path d="M175.838,129.267l.773-22.6H160.54v22.6Z" transform="translate(-105.405 -60.1)"
                        fill="#b36453"></path>
                      <path d="M164.11,129.72V110.24h12.9l-.668,19.48Z" transform="translate(-107.416 -62.112)"
                        fill="#75381e"></path>
                      <path d="M164.11,129.72V110.24h12.9l-.668,19.48Z" transform="translate(-107.416 -62.112)"
                        fill="url(#p)"></path>
                      <path d="M167.627,110.89H164.92v7.26l3.025-.031a43.362,43.362,0,0,1-.319-7.23Z"
                        transform="translate(-107.872 -62.478)" fill="url(#q)"></path>
                      <path d="M173.95,118.111q2.619-.026,5.2-.035V110.89h-5.2Z" transform="translate(-112.96 -62.478)"
                        fill="url(#r)"></path>
                      <path d="M188.23,110.89v7.19h2.07l.306-7.19Z" transform="translate(-121.006 -62.478)"
                        fill="url(#s)"></path>
                      <path d="M162.24,128.55h14.123v1.126l-14.123.62Z" transform="translate(-106.362 -72.428)"
                        fill="#b36453"></path>
                      <rect width="14.119" height="1.397" transform="translate(21.309 55.603)" fill="#b36453"></rect>
                      <path d="M169.96,107.689l.31,9.186.912.694V107.51Z" transform="translate(-110.712 -60.574)"
                        fill="#b36453"></path>
                      <path d="M184.66,107.7v9.19l.886.729.336-10.05Z" transform="translate(-118.994 -60.607)"
                        fill="#b36453"></path>
                      <path d="M90.49,107.689l.306,9.186h.912V107.51Z" transform="translate(-65.937 -60.574)"
                        fill="#b36453"></path>
                      <path d="M105.18,107.7v9.19l.908.017.314-9.338Z" transform="translate(-74.214 -60.607)"
                        fill="#b36453"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="page-title">Welcome to Your Home Profile!</div>
        </div>

        <div class="form-wrapper" v-if="ready">
          <form-builder ref="myInfoForm" :schema="schema" v-model="form" :stepper-data="stepper" @status="$_saveStatus"
            @stepStatus="$_updateStepStatus" :current-step="currentStep"></form-builder>
        </div>
      </div>
    </div>
    <!-- <supporting-photos @images="$_updateEditedImages" /> -->
    <div class="row">
      <div class="col s12">
        <div class="end-of-profile">
          <button @click="$_saveData(true)" :disabled="isProcessing || status.invalid"
            class="btn-large btn-rounded waves-effect indigo accent-2">
            Save &amp; Continue
          </button>
        </div>
      </div>
    </div>
    <app-bottom-tab></app-bottom-tab>
    <div class="control-container hide">
      <div class="control-bar z-depth-2">
        <button class="btn btn-flat waves-effect btn-rounded white black-text col s5 m2" @click="$_goTo()">
          Back
        </button>
        <button class="btn waves-effect amber lighten-1 btn-rounded black-text col s5 m2 right shadow-depth"
          :disabled="isProcessing || status.invalid" @click="$_saveData()">
          Save
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import appBottomTab from "@/components/AppBottomTab";
import homeProfileImage from "@/assets/home_profile.svg";
import TheTopBar from "@/components/TheTopBar.vue";
import FormBuilder from "@/components/formBuilder/FormBuilder.vue";
import { schema } from "@/schemas/myInfo.js";
import { toastMessage } from "@/common/util";
import { mapActions, mapState } from "vuex";
import M from "materialize-css";
import SupportingPhotos from "@/components/HomeProfile/SupportingPhotos";
import { updateUserProfile, uploadHomeProfileImages } from "@/api/user.api";
// import axios from "axios";
// import { getCookie } from "@/common/util"
export default {
  name: "MyInfo",
  components: { TheTopBar, FormBuilder, SupportingPhotos, appBottomTab },
  props: {},
  data() {
    return {
      schema,
      homeProfileImage,
      status: {
        invalid: false,
      },
      form: {},
      houseImages: [],
      currentStep: 1,
      stepper: {
        stepStatus: false,
        canPrev: false,
        canNext: false,
      },
      isProcessing: false,
      ready: false,
      editImages: [],
    };
  },
  beforeDestroy() {
    this.$_saveData();
  },
  mounted() {
    this.$_getFormData();
  },
  computed: {
    ...mapState({ user: (state) => state.User.user }),
  },
  methods: {
    ...mapActions("User", ["updateUser"]),
    $_getFormData() {
      const homeProfile = JSON.parse(localStorage.getItem('hp') || '{}')
      this.form = homeProfile
      this.ready = true;
    },
    $_goTo() {
      this.$router.go(-1);
    },

    $_saveStatus(status) {
      Object.assign(this.status, status);
    },
    $_updateEditedImages(val) {
      this.editImages = val;
    },
    $_updateStepStatus(stepInfo) {
      // console.log(stepStatus);
      Object.assign(this.stepper, stepInfo);
    },
    async $_saveData(v) {
      if (this.isProcessing || this.status.invalid) return;
      this.isProcessing = true;

      const { name, email } = this.form

      try {
        localStorage.setItem("hp", JSON.stringify(this.form));

        this.updateUser({ name: name || '', email: email || '', home_profile: JSON.stringify(this.form) })

        if (v) {
          this.$router.push({ name: 'Home' })
        }
      } catch (err) {
        console.log(err)
        toastMessage("Could not save data. Please try again later.");
      } finally {
        this.isProcessing = false;
      }
    },

  },
};
</script>
<style lang="scss" scoped>
#my-info {
  .contents {
    padding: 12px 16px 0px;
  }

  .page-title {
    font-size: 26px;
    margin: 22px 14px 6px;
    position: relative;
    text-align: center;
    color: white;
  }
}

.control-container {
  height: 68px;
  position: relative;

  .control-bar {
    z-index: 99;
    position: fixed;
    bottom: 0;
    left: 0;
    background: white;
    width: 100%;
    padding: 16px;

    button {
      min-width: 140px;
    }
  }
}

.site-constrains {
  max-width: 690px;
  margin: auto;

  .home-profile-header {
    border-radius: 8px;
    overflow: hidden;
    max-width: 650px;
    margin: 10px 20px 24px;
    padding: 22px;
  }
}

.title-image {
  width: 120px;
  height: 120px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  position: relative;
  margin: auto;

  svg {
    width: 150px;
    position: absolute;
    left: -14px;
    top: -6px;
  }

  &::after {
    content: " ";
    position: absolute;
    left: -6px;
    width: calc(100% + 12px);
    height: calc(100% + 12px);
    border-radius: 50%;
    border: 2px solid white;
    top: -6px;
  }
}

.end-of-profile {
  margin-bottom: 64px;
  text-align: center;
  padding: 24px;

  button {
    width: 200px;
  }
}
</style>

<style lang="scss">
.site-constrains {
  .select-wrapper {
    .dropdown-content {
      max-height: 40vh !important;
    }
  }
}

/* .house-info-input {
  background: #fff !important;
  box-shadow: none !important;
  // border: 1px solid rgba(112, 112, 112, 0.3) !important;
  border: none !important;
  border-radius: 5px !important;
  text-indent: 5px !important;
}

.distance-label {
  // color: #545454;
  font-weight: 400 !important;
  // padding-left: 1rem;
}

.hm-label {
  display: flex;
  height: 42px;
  align-items: center;
}

.hm-input {
  border: 1px solid rgba(112, 112, 112, 0.3) !important;
  border-radius: 5px !important;
  box-shadow: none !important;
  text-indent: 5px !important;
}
 */
///
.form-wrapper {
  .card {
    border-radius: 10px;

    .card-content {
      padding: 24px;
    }
  }
}

#my-info {
  .form-field-wrapper {
    padding: 0 8px !important;

    .full-width {
      margin: 16px -8px 24px !important;
      width: calc(100% + 16px) !important;
    }
  }
}
</style>
